// Phase 2 — product focus.
// A short, curated list of the tools we actively promote. Everything else in
// the registry is still available, just grouped under "Labs" so the menu stays
// small enough to be useful.

export const PRIMARY_TOOL_IDS = [
  "chat",
  "contract-risk-analyzer",
  "ai-image-generator",
  "geniebot-rezzy",
  "pdf-storybook-architect",
  "cyber-security",
  "blog-assistant",
  "travel-agent",
  "geniebot-tutor",
  "ai-video-generator",
] as const;

export type PrimaryToolId = (typeof PRIMARY_TOOL_IDS)[number];

const primarySet = new Set<string>(PRIMARY_TOOL_IDS);

export const isPrimaryTool = (toolId: string): boolean => primarySet.has(toolId);

export const isLabsTool = (toolId: string): boolean => !primarySet.has(toolId);

/** Sort helper: primary tools first, then alphabetical. */
export const byPrimaryThenName = <T extends { id: string; name: string }>(a: T, b: T): number => {
  const diff = Number(isLabsTool(a.id)) - Number(isLabsTool(b.id));
  return diff !== 0 ? diff : a.name.localeCompare(b.name);
};
